import { Status } from '@/components/common/Status'
import { WaveIcon } from '@/components/common/icons'

/**
 * Post-logout landing card.
 *
 * Reached only via Passport's `post_logout_redirect_uri` — i.e. the user
 * was explicitly signed out a moment ago. Plain users landing on `/`
 * without a session are redirected to Passport by `RequireAuth`, not
 * funnelled through this screen.
 *
 * Deliberately minimal: acknowledge the logout, nothing else. Signing back
 * in happens by navigating to `/`, which `RequireAuth` hands to Passport.
 */
export function SignedOutCard() {
  return (
    <Status tone="ok" icon={<WaveIcon />} title={<>You&rsquo;re signed out.</>}>
      See you next time.
    </Status>
  )
}
